import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';

import theme from './theme';

export const withChakra = (component: () => React.ReactNode) => () => {
	return <ChakraProvider theme={theme}>{component()}</ChakraProvider>;
};
